import MainLayout from "@/components/layout/MainLayout";
import DashboardWidgets from "@/components/dashboard/DashboardWidgets";
import { Helmet } from "react-helmet";

export default function Dashboard() {
  return (
    <MainLayout>
      <Helmet>
        <title>Dashboard | Dynamatix Intranet</title>
      </Helmet>
      <DashboardWidgets />
    </MainLayout>
  );
}
